"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.user", {
      url: "user",
      resolve: {
        list: [
          "$stateParams",
          "User",
          function ($stateParams, User) {
            return User.list().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/user/views/user.list.html",
          controller: "userListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.user-passwordchange", {
      url: "user/passwordchange",
      resolve: {
        model: [
          "User",
          function (User) {
            return User.current().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/user/views/user.password.change.html",
          controller: "userPasswordChangeCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.user-invite", {
      url: "user/invite",
      views: {
        main: {
          templateUrl:
            "/modules/Commom/user/views/user.invite.html",
          controller: "userInviteCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.user-edit", {
      url: "user/:id",
      resolve: {
        model: [
          "$stateParams",
          "User",
          function ($stateParams, User) {
            if ($stateParams.id) {
              return User.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
        language: [
          "Enumerators",
          function (Enumerators) {
            return Enumerators.query({ name: "language" }).$promise;
          },
        ],
        groups: [
          "Internal",
          function (Internal) {
            return Internal.groups().$promise;
          },
        ],
        states: [
          "Internal",
          function (Internal) {
            return Internal.states().$promise;
          },
        ],
        salesTeam: [
          "$stateParams",
          "User",
          function ($stateParams, User) {
            var params = {
              page: 1,
              pageSize: 1000,
              editingUserIdEditing: $stateParams.id,
            };

            return User.listSalesTeam(params).$promise;
          },
        ],
        subAreas: [
          "$stateParams",
          "BonusRequest",
          function ($stateParams, BonusRequest) {
            return BonusRequest.subAreas().$promise;
          },
        ],
        managersColor: [
          "Internal",
          function (Internal) {
            return Internal.ownUsersList({ isManager: true }).$promise;
          },
        ],
        customersOwn: [
          "Customer",
          function (Customer) {
            return Customer.customersOwnList().$promise;
          },
        ],
        approvers: [
          "Internal",
          function (Internal) {
            return Internal.approvers().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl: "/modules/Commom/user/views/user.edit.html",
          controller: "userEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
